import UUIDBase from '../UUIDBase'
import CustomerAttachment from "@/models/customer/CustomerAttachment";
import CustomerPet from "@/models/customer/CustomerPet";

export const customerI18nMessages = {
  en: {
    name: 'Customer Name',
    businessName: 'Business Name',
    customerDisplayName: 'Customer Full Name',
    email: 'Email',
    phone: 'Phone',
    phone2: 'Phone #2',

    streetAddress: 'Street Address',
    city: 'City',
    postalCode: 'Postal Code',
    country: 'Country',
    customerType: 'Customer Type',
    regular: 'regular',
    wholesale: 'regular',
    dateOfBirth: 'Date of birth',
    selectCustomer: 'Select a customer',
    neighborhood: 'Neighborhood',
    notes: 'Notes',
  },
  ar: {
    name: 'اسم الزبون',
    businessName: 'اسم الشركة',
    customerDisplayName: 'اسم الزبون',
    email: 'البريد الالكتروني',
    phone: 'رقم الهاتف',
    phone2: 'رقم الهاتف 2',

    streetAddress: 'عنوان الزبون',
    city: 'المدينة',
    postalCode: 'الرمز البريدي',
    country: 'الدولة',
    customerType: 'نوع العميل',
    regular: 'عام',
    wholesale: 'جملة',
    dateOfBirth: 'تاريخ الميلاد',
    selectCustomer: 'اختر زبون',
    neighborhood: 'الحي',
    notes: 'الملاحظات',
  }
}
export interface CustomersPaginated {
  data: Array<Customer>,
  total: number
}

export default class Customer extends UUIDBase {
  static from(json: Record<string, unknown> | Customer) {
    return Object.assign(new Customer(), json)
  }
  static ENDPOINT = '/customer/customers'
  static INVOICES_ENDPOINT = 'accounting/customerinvoices?customer_id='

  businessName = ''
  name = ''
  email = ''
  phone = ''
  phone2 = ''
  customerType = ''
  streetAddress = ''
  city = ''
  neighborhood = ''
  notes = ''
  postalCode = ''
  country = ''
  dateOfBirth = null
  customerAttachments: Array<CustomerAttachment> = [];
  customerPets: Array<CustomerPet> = [];
  isStarred: boolean = false;

  get contactDisplayName() {
    return `${this.name}`
  }
}
